import React, { useState } from "react";
import LocationSelect from "./LocationSelect";
import { useNavigate } from "react-router-dom";
import './SearchBox.scss';

const SearchBox = (props) => {
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [errorMessage, setErrorMessage] = useState(false);
  const navigate = useNavigate();

  return (
    <div className="SearchBox">
      <span className="location-selector">
        <label>My Location</label>
        <LocationSelect onChange={(selectedOptions) => {
          setSelectedOptions(selectedOptions);
          setErrorMessage(false);
        }} />
        {errorMessage ? <p className="error">{errorMessage}</p> : <p className="error">&nbsp;</p>}
      </span>
      <span className="search-button">
        <a className="btn-theme-second" href="/search" onClick={(ev) => {
          ev.preventDefault();
          if (! selectedOptions || selectedOptions.length < 1) {
            setErrorMessage('Please select at least one location.');
            return;
          } else {
            setErrorMessage(false);
          }
          const baseUrl = new URL(ev.target.href);
          const zipcodesFlattened = selectedOptions.map((option) => option.value).join(',');
          navigate({ pathname: baseUrl.pathname, search: '?zipcode=' + encodeURIComponent(zipcodesFlattened) });
        }}>Search</a>
      </span>
    </div>
  );
};

export default SearchBox;
